import { useTheme } from '@mui/material'

import { Markdown } from '../../components'

export const MarkdownCell = ({ value }: { value: string }) => {
  const theme = useTheme()
  return <Markdown color={theme.palette.text.primary}>{value}</Markdown>
}
